import { coupon_type_enums } from "shared/utils/constants";

export const headings = {
  mainHeading: "All Promo Codes Listing",
  subHeading: "Manage all promotional codes and discounts here",
};

export const columnHeadings = [
  {
    id: "code",
    title: "Promo Code",
  },
  {
    id: "discount",
    title: "Discount",
  },
  {
    id: "usage",
    title: "Usage",
  },
  {
    id: "valid_period",
    title: "Valid Period",
  },
  {
    id: "status",
    title: "Status",
  },
  {
    id: "actions",
    title: "Actions",
  },
];

export const skeletonInfo = {
  rows: 10,
  cellCount: 6,
  actions: 3,
};

export const filterOptions = [
  {
    option: "All",
    value: null,
  },
  {
    option: "Active",
    value: 1,
  },
  {
    option: "Inactive",
    value: 0,
  },
];

// Kept short: the selected option renders in a fixed-position chip
export const typeFilterOptions = [
  {
    option: "All",
    value: null,
  },
  {
    option: "Percentage",
    value: coupon_type_enums.percentage,
  },
  {
    option: "Flat price",
    value: coupon_type_enums.flat,
  },
];
